import { useCallback, useRef, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

const STATE_CHANGE_TIMEOUT = 100;
const CLEAR_ANCHOR_TIMEOUT = 300;

export const useSupportImportBriefMenu = () => {
  const menuRef = useRef(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);

  const clearAnchor = useDebouncedCallback(() => {
    setMenuAnchor(null);
  }, CLEAR_ANCHOR_TIMEOUT);

  const debouncedOpen = useDebouncedCallback((anchor) => {
    clearAnchor.cancel();

    if (anchor === menuAnchor) {
      return;
    }

    setMenuAnchor(anchor);
    setMenuVisible(true);
  }, STATE_CHANGE_TIMEOUT);

  const debouncedClose = useDebouncedCallback(() => {
    setMenuVisible(false);
  }, STATE_CHANGE_TIMEOUT);

  const handleBriefFieldFocus = useCallback(
    (event) => {
      debouncedOpen(event.target);
    },
    [debouncedOpen]
  );

  const handleBriefFieldBlur = useCallback(
    (event) => {
      // Don't close menu if focus is on menu
      const { relatedTarget } = event;
      if (menuRef.current && menuRef.current.contains(relatedTarget)) {
        return;
      }

      debouncedClose();
      clearAnchor();
    },
    [debouncedClose, clearAnchor]
  );

  const closeImportMenu = useCallback(() => {
    if (menuAnchor) {
      menuAnchor.focus();
    }
    setMenuVisible(false);
  }, [menuAnchor]);

  return {
    menuRef,
    menuAnchor,
    menuVisible,
    handleBriefFieldFocus,
    handleBriefFieldBlur,
    closeImportMenu,
  };
};
